import { apiRequest } from "../api/http";

// The list is public; changes are admin only ("legal" section). All of them
// reject on failure.
const options = { rethrow: true };

export function getSocialChannels() {
  return apiRequest(
    "get",
    "/api/social/get-all-social-media-platforms",
    options
  );
}

export function addSocialChannel(channel) {
  return apiRequest("post", "/api/social/add-social-media-platform", {
    ...options,
    data: channel,
  });
}

export function updateSocialChannel(id, { link, name }) {
  return apiRequest("put", `/api/social/update-social-media-platform/${id}`, {
    ...options,
    data: { link, name },
  });
}

export function updateSocialChannelIcon(id, { public_id, iconBase64 }) {
  return apiRequest("put", `/api/social/update-icon/${id}`, {
    ...options,
    data: { public_id, iconBase64 },
  });
}

export function deleteSocialChannel(id) {
  return apiRequest(
    "delete",
    `/api/social/delete-social-media-platform/${id}`,
    options
  );
}
